export default __webpack_public_path__ + "static/seamless-experience-a4779fff15590d8775ba5bdf8599f9c2.png";